import { CardFooter } from "@/components/ui/card";
import CardButton from "./CardButton";

const Footer = ({ name, pk, productSlug, category, price }) => {
  return (
    <div className="hidden sm:block pt-1">
      <CardFooter
        className="
        invisible opacity-0
        gap-2 justify-center p-0 h-0 
        scale-0 flex flex-col 
        group-hover:h-auto 
        group-hover:visible
        group-hover:opacity-100
        group-hover:scale-100
        transition-[opacity,transform]
        duration-100 ease-in-out 
      "
      >
        <CardButton 
          name={name}
          pk={pk}
          price={price}
          category={category}
          productSlug={productSlug}
        />
      </CardFooter>
    </div>
  );
};

export default Footer;
